export const otherIssues = [
  {
    value: 'none',
    label: 'None',
  },
  {
    value: 'DR',
    label: 'Race or ethnicity',
  },
  {
    value: 'DS',
    label: 'Sex/gender',
  },
  {
    value: 'DP',
    label: 'Pregnancy',
  },
  {
    value: 'DM',
    label: 'Maternity',
  },
  {
    value: 'DD',
    label: 'Physical or Mental health condition',
  },
  {
    value: 'DA',
    label: 'Age',
  },
  {
    value: 'DRn',
    label: 'Religious belief',
  },
  {
    value: 'DPl',
    label: 'Philosophical belief',
  },
  {
    value: 'DSy',
    label: 'Sexual orientation',
  },
  {
    value: 'DG',
    label: 'Gender reassignment',
  },
  {
    value: 'DMe',
    label: 'Marital or civil partnership status',
  },
];

export const otherIssuesForCDF = [
  ...otherIssues.filter(item => item.value !== 'none'),
  { value: 'ORT', label: 'Other' },
];
